import { IcImport } from '@assets/icons/24x24';
import { Box, Button, Icon, IconButton } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { ChangeEvent, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type Props = {
  label: string;
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
  accept?: string;
} & (
  | {
      isIconButton?: true;
      variant?: 'cockpitHeader' | 'transparent';
      boxSize?: string;
    }
  | {
      isIconButton: false;
      variant?: never;
      boxSize?: never;
    }
);

export function ImportFileButton({
  isIconButton = true,
  label,
  onFileChange,
  isLoading,
  accept,
  variant = 'cockpitHeader',
  boxSize = '56px',
}: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.click();
    }
  };

  return isIconButton ? (
    <Tooltip content={formatMessage({ id: label })}>
      <Box>
        <input type="file" ref={inputRef} accept={accept} style={{ display: 'none' }} onChange={onFileChange} />
        <IconButton aria-label="Import file" onClick={onClick} variant={variant} boxSize={boxSize} loading={isLoading}>
          <Icon as={IcImport} boxSize="24px" />
        </IconButton>
      </Box>
    </Tooltip>
  ) : (
    <Box width="100%">
      <input type="file" ref={inputRef} accept={accept} style={{ display: 'none' }} onChange={onFileChange} />
      <Button variant="toggle" size="toggleM" flex={1} aria-label="Import file" loading={isLoading} onClick={onClick}>
        <FormattedMessage id={label} />
      </Button>
    </Box>
  );
}
